import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

interface ProductListState {
	loaded: number;
	total: number;
}

const productListStateAtom = atom<ProductListState>({
	loaded: 0,
	total: 0,
});

export const useProductListState = () => {
	return useAtom(productListStateAtom);
};

export const useProductListStateValue = () => {
	return useAtomValue(productListStateAtom);
};

export const useSetProductListState = () => {
	return useSetAtom(productListStateAtom);
};
